/** Download an authorized private document through the authenticated API. */
import { saveAs } from 'file-saver';
import { authFetch } from './authFetch';

export async function downloadAssetDocument(path: string, filename: string): Promise<void> {
  const response = await authFetch(path);
  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error || 'Failed to retrieve document');
  }
  saveAs(await response.blob(), filename);
}
